module.exports = __webpack_public_path__ + "static/media/rightArrow.f56c8646.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wheel_icons/rightArrow.svg
// module id = 2373
// module chunks = 2